export default "__VITE_ASSET__7e6PEuO4__"